import * as $ from "jquery";
import CartService from "../Components/components.cart";
import CurrencyService from "../Services/service.currency";
import Handlebars from "Handlebars";

export default class SearchComponent {
    constructor() {
        this.componentSelector = "#product-search";
        this.instance = this;
        this.debounceTimer = null;
        this.lastQuery = "";
        this.cart = new CartService();
        this.lastHash = "";
        this.currencyFormatter = new CurrencyService();
        this.cartTemplateSelector = "#checkout-cart-template";
        this.cartErrorsTemplateSelector = "#checkout-carterrors-template";
        this.shippingTemplateSelector = "#checkout-shipping-template";
        this.cartResultSelector = "#checkout-cart";
        this.cartErrorsSelector = "#checkout-cart-errors";
        this.shippingResultSelector = "#checkout-shipping";
        this.searchResultTemplate;
        this.cartErrorsTemplate;
        this.shippingTemplate;
        this.checkoutModel;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();

            const cartTemplate = $(this.cartTemplateSelector).html();
            const cartErrorsTemplate = $(this.cartErrorsTemplateSelector).html();
            const shipTemplate = $(this.shippingTemplateSelector).html();
            if (cartTemplate !== undefined) {
                this.searchResultTemplate = Handlebars.compile(cartTemplate);
                this.shippingTemplate = Handlebars.compile(shipTemplate);
                this.cartErrorsTemplate = Handlebars.compile(cartErrorsTemplate);
            }
        }
        window._briqpay.subscribe('addressupdate', function (data) {
            $('.checkout-page').attr('data-zip', data.shippingaddress.zip);
            instance.updateNShift(instance.checkoutModel, instance)
        });

        $('#query1').focus();
    }

    bind() {
        let instance = this;

        $('#query2').off().on('keyup', function () {
            clearTimeout(instance.debounceTimer);
            instance.debounceTimer = setTimeout(function () {
                instance.search(instance, 1);
            }, 250);
        });

        $('#cart').on('mouseenter', function () {
            $(this).addClass('active');
        });

        $('#cart').on('mouseleave', function () {
            $(this).removeClass('active');
        });

        this.cart.cart(instance.showCart, instance);
    }

    bindCart(instance) {
        $('.js-cart-quantity').off().on('blur', function () {
            instance.validateQuantity(this);
            instance.changeQuantity(this, instance);
        });

        $('.js-cart-quantity').on('keypress', function (e) {
            if (e.which == 13) {
                instance.validateQuantity(this);
                instance.changeQuantity(this, instance);
            }
        });

        $('.js-cart-quantity-increase').off().on('click', function () {
            instance.increase(this);
            instance.changeQuantity(this, instance);
        });

        $('.js-cart-quantity-decrease').off().on('click', function () {
            instance.decrease(this);
            instance.changeQuantity(this, instance);
        });

        $('.js-cart-quantity-remove').off().on('click', function () {
            instance.removeLine(this, instance);
        });

        $('.checkout-shipping-method-button').off().on('click', function () {
            if (!$(this).hasClass('active')) {
                $('.checkout-shipping-methods .active').removeClass('active');
                $(this).addClass('active');
                $(this).find("input[type='radio']").prop("checked", true);
                instance.lockCheckout();
                instance.changeShipping(this, instance);
            };
        });

        $('#cart-pay-by-link').off().on('click', function () {
            instance.payByLink(instance);
        });

        $('#cart-pay-by-invoice').off().on('click', function () {
            instance.payByInvoice(instance);
        });

        $('.js-add-rebate-row').off().on('click', function () {
            var sku = $(this).attr('data-sku');
            var max = $(this).attr('data-max');
            var qty = $(this).parent().parent().find('.js-cart-quantity').attr('data-quantity');
            instance.addRebateRow(instance, sku, qty, this);
        });

        $('#checkout-promocode').off().on('blur', function () {
            instance.updatePromoCode(instance);
        });

        $('#checkout-promocode').on('keypress', function (e) {
            if (e.which == 13) {
                instance.updatePromoCode(instance);
            }
        });

        $('#checkout-affiliatepoints').off().on('blur', function () {
            instance.updateAffiliatePoints(instance);
        });

        $('#checkout-affiliatepoints').on('keypress', function (e) {
            if (e.which == 13) {
                instance.updateAffiliatePoints(instance);
            }
        });

        $('.js-use-all-affiliate-points').off().on('click', function () {
            var max = $('#checkout-affiliatepoints').attr('data-maxvalue');
            $('#checkout-affiliatepoints').val(max);
            instance.updateAffiliatePoints(instance);
        });
    }

    addSkuWatch(instance, sku, el) {
        axios({
            method: 'post',
            url: "/productsearch/AddNewStockNotification",
            data: { sku: sku }
        }).then(function (response) {
            if (response.data.toLowerCase() == "true") {
                $(el).hide()
                $(el).parent().find('.remove-skuwatch').show();
            }
            else {
                bootbox.alert("Ett fel inträffade.");
            }
        }).catch(function (response) {
            console.log(response);
        });
        
    }

    removeSkuWatch(instance, sku, el) {
        axios({
            method: 'post',
            url: "/productsearch/CancelStockNotification",
            data: { sku: sku }
        }).then(function (response) {
            if (response.data.toLowerCase() == "true") {
                $(el).parent().hide()
                $(el).parent().parent().find('.js-add-skuwatch').show();
            }
            else {
                bootbox.alert("Ett fel inträffade.");
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    updateAffiliatePoints(instance) {
        var currentValue = $('#checkout-affiliatepoints').attr('data-currentvalue');
        var newValue = $('#checkout-affiliatepoints').val();

        if (newValue == "")
            newValue = "0";

        if (currentValue != newValue) {

            instance.lockCheckout();
            axios({
                method: 'post',
                url: "/cart/UpdateAffiliateBonus",
                data: { affiliateBonus: newValue }
            }).then(function (response) {
                console.log(response.data);
                if (response.data) {
                    instance.cart.cart(instance.showCart, instance);
                    newValue = parseFloat(response.data);
                    if (newValue > 0)
                        $('.affiliate-points-wrapper').addClass("active");
                    else
                        $('.affiliate-points-wrapper').removeClass("active");

                } else {
                    instance.unlockCheckout();
                    $('.affiliate-points-wrapper').removeClass("active");
                }
            }).catch(function (response) {
                console.log(response);
            });

            $('#checkout-affiliatepoints').attr('data-currentvalue', newValue);
            $('#checkout-affiliatepoints').val(newValue);
        }
    }

    updatePromoCode(instance) {
        var currentValue = $('#checkout-promocode').attr('data-value');
        var newValue = $('#checkout-promocode').val();

        if (currentValue != newValue) {

            instance.lockCheckout();
            axios({
                method: 'post',
                url: "/cart/updatepromocode",
                data: { code: newValue }
            }).then(function (response) {
                console.log(response.data);
                if (response.data) {
                    instance.cart.cart(instance.showCart, instance);
                    if (response.data == "true")
                        $('.promotion-code-wrapper').addClass("active");
                    else
                        $('.promotion-code-wrapper').removeClass("active");

                } else {
                    instance.unlockCheckout();
                    $('.promotion-code-wrapper').removeClass("active");
                }
            }).catch(function (response) {
                console.log(response);
            });

            $('#checkout-promocode').attr('data-value', newValue);
        }
    }

    addRebateRow(instance, sku, qty, el, max) {
        bootbox.prompt({
            title: "Lägg till rabattrad",
            message: "Ange antal procent i rabatt (max " + max + "%)",
            inputType: 'number',
            callback: function (result) {
                if (result != null) {
                    if (parseInt(result) > 100)
                        result = 100;

                    instance.lockCheckout();
                    var rebateSku = sku + "_" + result + "_B";
                    instance.addToCart(rebateSku, qty, instance, true);

                    var currentLine = $(el).parent().parent().find('.js-cart-quantity-remove');

                    $(el).parent().parent().css('opacity', '0.4');
                    instance.removeLine($(currentLine), instance);
                }
            }
        });
    }

    payByLink(instance) {
        var email = $('#paybylink-email').val();
        bootbox.confirm({
            message: "<h3>Skicka betallänk?</h3> <p>Är du säker på att du vill skicka en betallänk till följande e-postadress?</p> <p><b>" + email + "</b> </p>",
            buttons: {
                confirm: {
                    label: 'Ja, skicka',
                    className: 'btn-lg btn-pink'
                },
                cancel: {
                    label: 'Nej',
                    className: 'btn-lg'
                }
            },
            callback: function (result) {
                if (result) {
                    instance.confirmPayByLink(instance);
                }
                console.log('This was logged in the callback: ' + result);
            }
        });
    }

    payByInvoice(instance) {

        $('#briqpay').html("");

        var dontSendReceipt = $('#invoice-no-receipt').prop('checked');

        axios({
            method: 'post',
            url: "/cart/briqpay",
            data: { dontSendReceipt: dontSendReceipt }
        }).then(function (response) {
            $('#briqpay').html(response.data);
        }).catch(function (response) {
        });
    }

    confirmPayByLink(instance) {
        var method = "email";
        var email = $('#paybylink-email').val();
        var phone = "";

        axios({
            method: 'post',
            url: "/cart/paybylink",
            data: { method: method, email: email, phone: phone }
        }).then(function (response) {
            instance.callbackPayByLink(response.data);
        }).catch(function (response) {
        });
    }

    callbackPayByLink(result) {
        var email = $('#paybylink-email').val();
        console.log(result);

        if (result == "true") {
            bootbox.confirm({
                message: "<h3>Betallänk skickad</h3> <p>Betallänk skickad till följande e-postadress:</p> <p><b>" + email + "</b> </p> <p>Kunden kan nu betala ordern själv. Välj Avsluta för att välja en ny kund eller Fortsätt för att ha sessionen kvar.</p>",
                buttons: {
                    confirm: {
                        label: 'Avsluta',
                        className: 'btn-lg btn-pink'
                    },
                    cancel: {
                        label: 'Fortsätt med kunden',
                        className: 'btn-lg'
                    }
                },
                callback: function (result) {
                    if (result) {
                        window.location.href = '/Customers?reset=1';
                    }
                    console.log('This was logged in the callback: ' + result);
                }
            });
        }
    }

    addToCart(sku, quantity, instance, isRebateRow) {
        var marketId = $('#cart').attr('data-marketid');
        instance.cart.add(sku, quantity, marketId, instance.showCart, instance, isRebateRow);
    }

    validateQuantity(el) {
        let quantity = $(el).val();
        if (!$.isNumeric(quantity)) {
            $(el).val(1);
        }

        if (parseInt($(el).val()) < 1) {
            $(el).val(1);
        }
    }

    increase(el) {
        let field = $(el).parent().find('.js-cart-quantity');
        let quantity = $(field).val();

        if (!$.isNumeric(quantity)) {
            quantity = 0;
        }

        if (parseInt(quantity) > 99) {
            return;
        }

        quantity++;
        $(field).val(quantity);
    }

    decrease(el) {
        let field = $(el).parent().find('.js-cart-quantity');
        let quantity = $(field).val();

        if (!$.isNumeric(quantity)) {
            quantity = 2;
        }

        if (parseInt(quantity) < 2) {
            return;
        }

        quantity--;
        $(field).val(quantity);
    }

    changeShipping(el, instance) {
        var method = $(el).attr('data-method');

        axios({
            method: 'post',
            url: "/cart/updateshipping",
            data: { method: method }
        }).then(function (response) {
            instance.showCart(response.data, instance);
        }).catch(function (response) {
            console.log(response);
        });
    }

    changeNShiftShipping(result, instance) {
        let serviceId = $(`[data-id=${result.selectedOptionId}]`).attr('data-serviceId')

        if (serviceId != null) {
            axios({
                method: 'post',
                url: "/cart/updatenshiftshipping",
                data: { serviceId: serviceId, agentId: result.agent, price: result.price, fields: result.fields }
            }).then(function (response) {
                instance.showCartSummary(response.data, instance, false);
            }).catch(function (response) {
                console.log(response);
            });
        }
    }

    removeLine(el, instance) {
        let quantity = $(el).attr('data-quantity');
        let sku = $(el).attr('data-sku');
        instance.lockCheckout();
        instance.addToCart(sku, 0 - quantity, instance);
    }

    lockCheckout() {
        $('.checkout-cart').addClass('locked');
        $('.checkout-shipping-methods').addClass('locked');
        //$('#briqpay').addClass('locked');

        var loader = '<div class="loader"></div>';
        $('#briqpay').html(loader);
    }

    unlockCheckout() {
        $('.checkout-cart').removeClass('locked');
        $('.checkout-shipping-methods').removeClass('locked');
        //$('#briqpay').removeClass('locked');
    }

    changeQuantity(el, instance) {
        let field = $(el).parent().find('.js-cart-quantity');
        let currentQuantity = $(field).attr('data-quantity');
        let sku = $(field).attr('data-sku');
        let newQuantity = $(field).val();

        if (currentQuantity != newQuantity) {
            var delta = newQuantity - currentQuantity;
            instance.lockCheckout();

            instance.addToCart(sku, delta, instance);
        }
    }

    search(instance, page) {
        var query1 = $('#query1').val();
        var query2 = $('#query2').val();
        var language = $('body').attr('data-lang');
        var hash = new Date().getTime();
        instance.lastHash = hash.toString();

        //Avoid repeating similar queries
        var queryKey = query1 + query2;
        if (instance.lastQuery == queryKey)
            return;
        instance.lastQuery = query1 + query2 + page;

        axios({
            method: 'post',
            url: "/productsearch/search",
            data: { query1: query1, query2: query2, language: language, hash: hash, page: page }
        }).then(function (response) {
            instance.render(response.data, instance, page);
        }).catch(function (response) {
            console.log(response);
        });
    }

    render(data, instance, page) {
        var html = $.parseHTML(data);
        var resultHash = "";

        if (page == 1)
            resultHash = $(html)[1].attributes[1].nodeValue.toString();

        if ((instance.lastHash === resultHash) || (page > 1)) {
            if (page <= 1) {
                $('#result').html(data);
                var total = $('.table.search-result').attr('data-total');
                $('.search-result--total').html("Hittade " + total + " artiklar");
            }
            else {
                $('.table-paginate-spinner').remove();
                $('#result tbody').append(data);
            }
            instance.currencyFormatter.formatNumber();
        } else {
            console.log("Hash mismatch - discarded result");
        }

        $('.skuwatch').each(function () {
            if ($(this).attr('data-savedforrequest').toLowerCase() === "true") {
                $(this).find(".remove-skuwatch").show();
            }
            else {
                $(this).find(".js-add-skuwatch").show();
            }
        })        

        $('.js-search-paginate').off().on('click', function () {
            var page = parseInt($('.js-search-paginate').attr('data-page')) + 1;
            instance.search(instance, page);
        })

        $('#result').off().on('scroll', function () {
            if ($(this).scrollTop() + $(this).innerHeight() >= ($(this)[0].scrollHeight) - 10) {
                if ($('#result .js-search-paginate').length) {
                    var page = parseInt($('.js-search-paginate').attr('data-page')) + 1;
                    $('#result .table-paginate-row').remove();
                    instance.search(instance, page);
                }
            }
        })

        $('.js-cart').off().on('click', function () {
            var el = $(this).parent().parent().find('.js-quantity');
            var sku = $(el).attr('data-sku');
            var qty = $(el).val();
            var marketId = $('#cart').attr('data-marketid');
            instance.lockCheckout();
            instance.cart.add(sku, qty, marketId, instance.showCart, instance);
        });

        $('.js-cart-bb').off().on('click', function () {
            var el = $(this).parent().parent().find('.js-quantity');
            var sku = $(el).attr('data-sku');
            var qty = $(el).val();
            var marketId = $('#cart').attr('data-marketid');

            instance.lockCheckout();
            sku = sku + "_50_BB";
            instance.cart.add(sku, qty, marketId, instance.showCart, instance);
        });

        $('.js-cart-ab').off().on('click', function () {
            var el = $(this).parent().parent().find('.js-quantity');
            var sku = $(el).attr('data-sku');
            var qty = $(el).val();
            var marketId = $('#cart').attr('data-marketid');

            instance.lockCheckout();
            sku = sku + "_100_AB";
            instance.cart.add(sku, qty, marketId, instance.showCart, instance);
        });

        $('.js-quantity').off().on('keyup', function (e) {
            if (e.which == 13) {
                var el = $(this);
                var sku = $(el).attr('data-sku');
                var qty = $(el).val();
                var marketId = $('#cart').attr('data-marketid');

                instance.lockCheckout();
                instance.cart.add(sku, qty, marketId, instance.showCart, instance);
                $('#query2').focus();
                $('#query2').select();
            }
        });

        $('.js-add-skuwatch').off().on('click', function () {
            var sku = $(this).attr('data-sku');
            instance.addSkuWatch(instance, sku, this);
        });

        $('.js-remove-skuwatch').off().on('click', function () {
            var sku = $(this).attr('data-sku');
            instance.removeSkuWatch(instance, sku, this);
        });
    }

    showCart(data, instance) {
        var checkout = JSON.parse(data);

        instance.checkoutModel = checkout;
        $.each(checkout.PromoItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.length - 1);
        });

        $.each(checkout.RebateItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.indexOf("_"));

            this.RebateType = "Kundtjänstrabatt";
            if (this.Sku.indexOf("_BB") > 0)
                this.RebateType = "Backbar";

            if (this.Sku.indexOf("_AB") > 0)
                this.RebateType = "Arbetsprodukt";
        });

        console.log(checkout);

        console.log($(instance.searchResultTemplate));

        $(instance.cartResultSelector).html(instance.searchResultTemplate(checkout));
        $(instance.shippingResultSelector).html(instance.shippingTemplate(checkout));

        if (checkout.CartItemErrors != null) {
            if (checkout.CartItemErrors.length > 0) {
                $(instance.cartErrorsSelector).html(instance.cartErrorsTemplate(checkout));
                $('.checkout-cart-errors').show();
            }
            else {
                $('.checkout-cart-errors').hide();
            }
        }

        $('#cart-total').html(checkout.TotalCostExVAT);
        $('#cart-total').removeClass('formatted');

        $('#cart-freight-free').html(checkout.FreightFeeNeeded);
        $('#cart-freight-free').removeClass('formatted');

        if (checkout.FreightFeeExpressNeeded > -1) {
            $('#cart-freight-fee-express-wrapper').show();
            $('#cart-freight-free-express').html(checkout.FreightFeeExpressNeeded);
            $('#cart-freight-free-express').removeClass('formatted');
        } else {
            $('#cart-freight-fee-express-wrapper').hide();
        }

        if (!$('.cart').hasClass('active')) {
            $('.cart').addClass('flash');
        }

        setTimeout(instance.deactivateCart, 1000);

        instance.updateDiscounts(checkout, instance);

        instance.currencyFormatter.formatNumber();

        instance.bindCart(instance);

        instance.unlockCheckout();

        let nshift = $('.checkout-page').data('usenshift');
        if (nshift == "True") {
            instance.updateNShift(checkout, instance);
        }

        if (checkout.HasError) {
            bootbox.alert({
                title: "Ett problem uppstod",
                message: checkout.ErrorMessage
            });
        }

        if (checkout.CartItemErrors.length) {
            bootbox.alert({
                title: "Ett problem uppstod",
                message: checkout.CartItemErrors[0].Error
            });
        }
    }

    updateDiscounts(data, instance) {
        $('#active-user-customer-discount-money').html(data.TotalCustomerDiscountsMoney);
        $('#active-user-customer-discount-percentage').html(data.TotalCustomerDiscountsPercentage + "%");
        $('#active-user-total-discount-percentage').html(data.TotalDiscountsPercentage + "%");
        $('#active-user-total-discount-money').html(data.TotalDiscountsMoney);

        $('.active-user-wrapper .formatted').removeClass('formatted');

        $('.active-user--discount').css('display', 'flex');
    }

    showCartSummary(data, instance) {
        var checkout = JSON.parse(data);

        $.each(checkout.PromoItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.length - 1);
        });

        $.each(checkout.RebateItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.indexOf("_"));

            this.RebateType = "Kundtjänstrabatt";
            if (this.Sku.indexOf("_BB") > 0)
                this.RebateType = "Backbar";

            if (this.Sku.indexOf("_AB") > 0)
                this.RebateType = "Arbetsprodukt";
        });

        console.log(checkout);

        $(instance.cartResultSelector).html(instance.searchResultTemplate(checkout));
        $(instance.shippingResultSelector).html(instance.shippingTemplate(checkout));

        if (checkout.CartItemErrors != null) {
            if (checkout.CartItemErrors.length > 0) {
                $(instance.cartErrorsSelector).html(instance.cartErrorsTemplate(checkout));
                $('.checkout-cart-errors').show();
            }
            else {
                $('.checkout-cart-errors').hide();
            }
        }

        $('#cart-total').html(checkout.TotalCostExVAT);
        $('#cart-total').removeClass('formatted');

        $('#cart-freight-free').html(checkout.FreightFeeNeeded);
        $('#cart-freight-free').removeClass('formatted');

        if (checkout.FreightFeeExpressNeeded > -1) {
            $('#cart-freight-fee-express-wrapper').show();
            $('#cart-freight-free-express').html(checkout.FreightFeeExpressNeeded);
            $('#cart-freight-free-express').removeClass('formatted');
        } else {
            $('#cart-freight-fee-express-wrapper').hide();
        }

        if (!$('.cart').hasClass('active')) {
            $('.cart').addClass('flash');
        }

        setTimeout(instance.deactivateCart, 1000);

        instance.updateDiscounts(checkout, instance);

        instance.currencyFormatter.formatNumber();

        instance.bindCart(instance);

        instance.unlockCheckout();

        if (checkout.HasError) {
            bootbox.alert({
                title: "Ett problem uppstod",
                message: checkout.ErrorMessage
            });
        }

    }

    nShiftCallback(e) {
        let instance = this;
        instance.changeNShiftShipping(e, instance);
    }

    updateNShift(data, instance) {
        let toMarket = $('.checkout-page').data('marketid');
        let toZip = $('.checkout-page').attr('data-zip');
        let cartTotal = data.TotalCostExVAT;

        let config = {};
        config.language = "sv";
        config.useIcons = true;
        config.iconsInFront = true;
        config.iconsBaseUrl = "https://api.unifaun.com/rs-extapi/v1/delivery-checkouts-widget/logos";
        config.narrowDisplay = false;
        config.narrowBreakpointWidth = 760;
        config.narrowBreakpointWidth = 340;
        config.resultCallback = instance.nShiftCallback.bind(instance);
        config.installCSS = "nshift-v2";
        config.enableMap = true;

        let containerElement = document.getElementById("checkout-nshift");
        let widget = UnifaunCheckout.createAt(containerElement, config);
        let url = `/nshift/index?market=${toMarket}&zip=${toZip}&cartTotal=${cartTotal}`;
        widget.disable();
        fetch(url).then(function (response) {
            return response.json();
        }).then(function (data) {
            var parsedData = JSON.parse(data);
            widget.updateList(parsedData);

            $('.nshift-option').each(function (index, value) {
                $(this).attr("data-serviceId", parsedData.options[index].serviceId)
                $(this).attr("data-id", parsedData.options[index].id)

                var serviceId = $(this).data("serviceid")
                if (serviceId == "DELIVERYCHECKOUTAGENT") {
                    $(this).attr("data-serviceId", "BUDBIL_EXP")
                    $(this).children('.nshift-folding-block').hide()
                }

                if (serviceId == "DELIVERYCHECKOUTSERVICE") {
                    $(this).attr("data-serviceId", "NOLABLE")
                }
            })
            widget.updateList(parsedData);

        }).catch(function () {
        }).then(function () {
            widget.enable();
        });
    }

    deactivateCart() {
        $('.cart').removeClass('flash');
    }
}